import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import ReportCardSubheading from '/component/base/ReportCardSubheading';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';
interface LoadingProps {
  tt: (key: string, defaultText?: string) => string;
  renderTitle: () => string;
}

export const Loading: React.FC<LoadingProps> = ({
  tt = (key, defaultText) => defaultText ?? key,
  renderTitle = () => '',
}) => {
  return (
    <View>
      <ReportCardSubheading
        label={tt('label.dateJoined', 'Date Joined')}
        value={<LoadingBox style={styles.loadingBoxDateJoined} />}
      />
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {renderTitle()}
        </Text>
      </Gutter>
      <Gutter style={styles.orderContainer}>
        <View style={styles.orderLine1}>
          <View style={styles.orderDate}>
            <Text>{tt('noOrderText', 'No Orders Yet')}</Text>
          </View>
          <View style={styles.orderAmount}>
            <Text style={styles.orderAmountEmptyText}>--</Text>
          </View>
        </View>
      </Gutter>
    </View>
  );
};

export default withTranslation('reportCardContent.newClientWithoutOrders')(
  Loading,
);
